import resourceConfig from "../config";

export default {
    resources: {
        [resourceConfig.name]: {
            name: 'Report |||| Reports',
            title: 'GIS MT Data',
            openAction: 'Open',
            executeAction: 'Submit',
            executeActionUit: 'Submit',
            successMessage: 'Request sent successfully',
            errorMessage: 'Error while sending request',
            sectionFile: 'File upload and addresses',
            sectionUit: 'Search by marking code',
            fields: {
                file: 'File (.xlsx)',
                addresses: 'Addresses',
                address: 'Address',
                uitCode: 'UIT Code',
            },
        }
    }
};